import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stateType } from './types';

const initialState: stateType = {
  isSound: false,
};

export const sound = createSlice({
  name: 'sound',
  initialState,
  reducers: {
    toggleSound(state) {
      state.isSound = !state.isSound;
    },
  },
});

export const { toggleSound } = sound.actions;

export default sound.reducer;
